<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.alias.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.alias.description') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="document-name-email"
        @change="update"
        data-vs-radio-button="alias"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.alias.option.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
       {{ $t('message.abm.folders.settings.alias.option.legend') }}
      </span>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="document-name-email"
        @change="update"
        data-vs-radio-button="aliasModify"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.alias.option1.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.alias.option1.legend') }}
      </span>
      <div class="w-full mt-8 custom-input" v-if="emailNameOverride">
        <zt-input
          ref="ztInputName"
          v-model="emailName"
          class="w-full"
          name="nb-subfolder-email"
          :color="errorText ? 'danger' : 'primary'"
          v-validate="{ required: true, min: 3, max:150 , regex: /^[a-zA-Z0-9\\s\\:ñÑàèìòùáéíóúäëïöü ]*$/ }"
          outlined
          label='Ingresa el nombre del documento'
          data-vs-input="email"
        />
        <span class="text-zt-danger absolute text-base pt-1" v-show="errorText">
          {{ errorText }}
        </span>
      </div>
    </div>
    <div class="w-full mt-8">
      <zt-button
        text
        class="text-zt-base button-preview flex items-center p-0"
        color="dark-300"
        @click="showPreview = true"
        data-vs-button="showPreview"
      >
        <zt-icon name="eye" class="mr-2" />
        <span>{{ $t('message.abm.folders.settings.alias.preview') }}</span>
      </zt-button>
    </div>
    <email-preview
      :active="showPreview"
      :name="nameInEmail"
    />
  </div>
</template>
<script>
import EmailPreview from '@/modules/Folders/components/modals/EmailPreview'
export default {
  name: 'SubFolderDocumentNameEmail',
  inject: ['stateFolder', 'setSubFolderParams'],
  provide() {
    return {
      activeEmailPreview: this.activeEmailPreview,
      stateFolder: this.stateFolder
    }
  },
  components: {
    EmailPreview
  },
  data() {
    return {
      showPreview: false,
      selected: '',
      emailNameOverride: false,
      emailName: ''
    }
  },
  computed: {
    errorText() {
      if (this.errors.first('nb-subfolder-email')) {
        return this.errors.first('nb-subfolder-email')
      }
      return ''
    },
    nameInEmail() {
      if (this.stateFolder.subFolderParams.emailName) {
       return this.stateFolder.subFolderParams.emailName
      }
      return this.stateFolder.subFolderParams.name
    }
  },
  created() {
    this.selected = this.stateFolder.subFolderParams.emailNameOverride.toString()
    this.emailNameOverride = this.stateFolder.subFolderParams.emailNameOverride
    this.emailName = this.stateFolder.subFolderParams.emailName
  },
  methods: {
    update() {
      const emailNameOverride = (/^(true|1)$/i).test(this.selected) && !!this.selected
      this.emailNameOverride = emailNameOverride
      if (!emailNameOverride) {
        this.emailName = ''
      }
      this.setSubFolderParams({
        emailName: emailNameOverride ? this.stateFolder.subFolderParams.emailName : '',
        emailNameOverride
      })
    },
    activeEmailPreview(active) {
      this.showPreview = active
    }
  },
  watch: {
    errorText() {
      if (this.$refs.ztInputName && this.$refs.ztInputName.$el && this.errorText) {
        this.$refs.ztInputName._data.isFocused = true
      }
    },
    emailName() {
      setTimeout(() => {
        if (!this.errorText) {
          this.setSubFolderParams({
            emailName: this.emailName
          })
        } else {
          this.setSubFolderParams({
            emailName: ''
          })
        }
      }, 10)
    }
  }
}
</script>
<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
.button-preview {
  font-size: 12px;
  color: #969696 !important;
}
::v-deep {
  .zt-input-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
  .zt-input-text-field {
    label {
      margin-bottom: 0;
    }
  }
  .zt-button {
    padding: 0!important;
    label {
      margin: 0!important;
    }
  }
}
</style>